$(function ()
{
    $('.slicknav-btn').click(function(){
        
        if ($('.slicknav_nav').is(':visible')) {
            $('.slicknav_nav').slideUp(500);
        }
        else {
            $('.slicknav_nav').slideDown(500);
        }
        
    });

    initMobileSearch();
});

function initMobileSearch() {
    $('.searchbar .search-icon').click(function () {

        let searchForm = $(this).parent().find('.search-form');

        if (searchForm.is(":hidden")) {
            searchForm.fadeIn();

            // odečteme 10px, abychom to měli vycentrované s lupou
            searchForm.css('top', ($(this).offset().top - 10) + 'px');
        } else {
            searchForm.fadeOut();
        }

    });

    // pokud klickneme na close, zavřeme
    $(".searchbar .close").click(function () {
        let searchForm = $(this).parent().parent().find('.search-form');
        searchForm.fadeOut();
    });

    $(".searchbar .icon").click(function () {
        // odeslání formuláře po kliknutí na ikonku lupy
        $('#searchBarSubmitMobile').trigger('click');
    });
}